"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var commonFunctions_1 = require("../../../../commonFunctions");
var services_1 = require("@falcon/services");
var RadioInput_1 = require("../../../../components/RadioInput");
var components_1 = require("@athena-portal/components");
// @ts-ignore
var browser_image_compression_1 = require("browser-image-compression");
var AnnualHomeBicycleModal = /** @class */ (function (_super) {
    __extends(AnnualHomeBicycleModal, _super);
    function AnnualHomeBicycleModal(props) {
        var _this = _super.call(this, props) || this;
        _this.numberOfImages = 2;
        _this.minValue = 350;
        _this.maxValue = 10000000;
        _this.state = {
            item: props.item,
            isOpen: true
        };
        _this.handleDescriptionChange = _this.handleDescriptionChange.bind(_this);
        _this.handleValueChange = _this.handleValueChange.bind(_this);
        _this.handleLocationChange = _this.handleLocationChange.bind(_this);
        _this.validateValue = _this.validateValue.bind(_this);
        _this.finishAddingItem = _this.finishAddingItem.bind(_this);
        _this.removeUnsavedAndClose = _this.removeUnsavedAndClose.bind(_this);
        _this.resetRemoveImagesFlagAndToggleClose = _this.resetRemoveImagesFlagAndToggleClose.bind(_this);
        return _this;
    }
    AnnualHomeBicycleModal.prototype.render = function () {
        var isMta = this.props.interaction.status === services_1.INTERACTION_STATUS_PENDING_MTA;
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 cover-amount-modal", isOpen: this.state.isOpen, toggle: isMta ? this.removeUnsavedAndClose : this.props.closeModal },
            React.createElement(reactstrap_1.ModalHeader, { toggle: isMta ? this.removeUnsavedAndClose : this.props.closeModal, close: React.createElement("button", { className: "btn-close", onClick: isMta ? this.removeUnsavedAndClose : this.props.closeModal }) },
                React.createElement("div", { className: "mb-4 text-blue-2 font-weight-medium" }, this.props.title)),
            React.createElement(reactstrap_1.ModalBody, { className: "py-0 fs-16 font-weight-extra-light", cssModule: { 'modal-body': 'modal-body-no-height-limit' } },
                React.createElement("p", null, "Add bicycles to be covered in and out from your home."),
                this.renderDescriptionInput(),
                this.renderValueInput(),
                this.renderCoverLocationRadio(),
                this.state.item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE && this.renderWarningBanner(),
                isMta && this.props.addPhotoEnabled && this.renderImageUpload(),
                this.renderHeadUpMessage(),
                this.renderFooter())));
    };
    AnnualHomeBicycleModal.prototype.removeUnsavedAndClose = function () {
        this.setState({
            removeUnsavedImagesFlag: true
        });
    };
    AnnualHomeBicycleModal.prototype.resetRemoveImagesFlagAndToggleClose = function () {
        this.setState({
            removeUnsavedImagesFlag: false
        });
        this.props.closeModal();
    };
    AnnualHomeBicycleModal.prototype.renderDescriptionInput = function () {
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "description" }, "Describe your bicycle"),
            React.createElement("div", { className: "input-group w-100" },
                React.createElement("input", { type: "text", id: "description", className: "form-control ".concat((0, commonFunctions_1.getValidationStyle)(this.state.isDescriptionValid)), value: this.state.item.description || "", maxLength: 100, onChange: this.handleDescriptionChange })),
            React.createElement("div", { className: "text-danger fs-14 font-weight-medium mt-2 mt-md-0" }, this.state.isDescriptionValid === false && "Please describe your bicycle")));
    };
    AnnualHomeBicycleModal.prototype.renderValueInput = function () {
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "value" },
                "How much would it cost to replace the item as new?",
                React.createElement("br", null),
                React.createElement("span", { className: "font-weight-extra-light" }, "(Include any bicycle accessory like a helmet, locks or front/rear lights)")),
            React.createElement("div", { className: "input-group d-flex align-items-center" },
                React.createElement("span", { className: "fs-22 font-weight-bold" }, "\u00A3"),
                React.createElement("input", { type: "text", id: "value", className: "form-control w-25 mx-2 ".concat((0, commonFunctions_1.getValidationStyle)(this.state.isValueValid)), value: this.state.item.value || "", onChange: this.handleValueChange }),
                React.createElement("span", null,
                    " (minimum \u00A3",
                    this.minValue,
                    ")")),
            React.createElement("div", { className: "text-danger fs-14 font-weight-medium margin-top-16 mt-md-0" },
                this.state.isValueValid === false && !this.state.item.value && "Please enter a value for your bicycle.",
                this.state.isValueValid === false && this.state.item.value && this.state.item.value < this.minValue && "All bicycles worth under \u00A3".concat(this.minValue, " are covered as standard in & away from the home."),
                this.state.isValueValid === false && this.state.item.value && this.state.item.value > this.maxValue && "Sorry, we can\u2019t insure you because of your bicycles.")));
    };
    ;
    AnnualHomeBicycleModal.prototype.renderCoverLocationRadio = function () {
        return (React.createElement(RadioInput_1.RadioInput, { label: "Do you want to cover this bicycle outside your home?", id: "coverOutsideHome", valueTrue: services_1.ValuableItemCoverLocation.ANYWHERE, valueFalse: services_1.ValuableItemCoverLocation.HOME, onChange: this.handleLocationChange, selectedValue: this.state.item.coverLocation, showValidationMessage: this.state.isLocationValid === false }));
    };
    AnnualHomeBicycleModal.prototype.renderWarningBanner = function () {
        return (React.createElement("div", { className: "banner", role: "alert" },
            React.createElement("img", { className: "d-block h-100 mr-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "warning-sign" }),
            React.createElement("div", { className: "banner-text" },
                React.createElement("p", null, "Your bicycle isn't covered for theft unless it's locked to an immovable object or kept within a locked building when taken away from home."))));
    };
    AnnualHomeBicycleModal.prototype.renderImageUpload = function () {
        return (React.createElement(services_1.MultiImageUploadPanel, { reference: this.props.item.valuableItemId, numberOfImages: this.numberOfImages, compressImage: this.compressImage, footerBlock: this.footerBlock, overlay: this.overlay, toggleParentModalClose: this.resetRemoveImagesFlagAndToggleClose, removeNewAddedImages: this.state.removeUnsavedImagesFlag === true }));
    };
    AnnualHomeBicycleModal.prototype.renderHeadUpMessage = function () {
        if (this.state.item.coverLocation === services_1.ValuableItemCoverLocation.HOME) {
            return (React.createElement("div", { className: "font-weight-extra-light text-center p-3 display-block banner banner-info" },
                React.createElement("div", { className: "text-align-left" },
                    "Heads up - ",
                    React.createElement("b", { className: "font-weight-semi-bold" }, " this bicycle is covered as standard inside your home, you don\u2019t need to specify it"))));
        }
        else if (this.props.interaction.process === services_1.INTERACTION_PROCESS_NB) {
            return (React.createElement("div", { className: "font-weight-extra-light text-center p-3 display-block banner banner-info" },
                React.createElement("div", { className: "text-align-left" },
                    "Heads up - ",
                    React.createElement("b", { className: "font-weight-semi-bold" }, " you\u2019ll be able to add images & receipts of the bicycle later in your account"))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomeBicycleModal.prototype.renderFooter = function () {
        return (React.createElement("div", { className: "d-block alert-close-buttons d-flex flex-column" },
            this.renderConfirmButton(),
            React.createElement("button", { type: "button", className: "btn btn-back width-md-250 display-block mb-1 mt-3", onClick: this.props.interaction.status === services_1.INTERACTION_STATUS_PENDING_MTA ? this.removeUnsavedAndClose : this.props.closeModal }, "Cancel")));
    };
    AnnualHomeBicycleModal.prototype.renderConfirmButton = function () {
        var style = "btn btn-primary btn-add width-md-250 display-block mb-1";
        if (this.state.item.coverLocation === services_1.ValuableItemCoverLocation.HOME) {
            return (React.createElement("button", { type: "button", className: style, onClick: this.props.closeModal }, "Okay, I understand"));
        }
        else {
            return (React.createElement("button", { type: "button", className: style, onClick: this.finishAddingItem }, this.props.title));
        }
    };
    ;
    AnnualHomeBicycleModal.prototype.compressImage = function (imageFile) {
        return (0, browser_image_compression_1.default)(imageFile, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: false
        });
    };
    AnnualHomeBicycleModal.prototype.overlay = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(components_1.Overlay, { show: true }));
    };
    AnnualHomeBicycleModal.prototype.footerBlock = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("label", null,
                React.createElement("b", null,
                    "Upload up to ",
                    this.numberOfImages,
                    " photos / receipts of your item")));
    };
    AnnualHomeBicycleModal.prototype.handleDescriptionChange = function (event) {
        var item = this.state.item;
        item.description = event.target.value;
        var isDescriptionValid = Boolean(item.description);
        this.setState({
            isDescriptionValid: isDescriptionValid
        });
    };
    ;
    AnnualHomeBicycleModal.prototype.handleValueChange = function (event) {
        var _this = this;
        if (event.target.value.match("^[0-9]*$")) {
            var item = this.state.item;
            item.value = event.target.value;
            this.setState({
                item: item
            }, function () {
                _this.validateValue(true);
            });
        }
    };
    AnnualHomeBicycleModal.prototype.handleLocationChange = function (event) {
        var item = this.state.item;
        item.coverLocation = event.target.value;
        var isLocationValid = Boolean(item.coverLocation);
        this.setState({
            isLocationValid: isLocationValid
        });
    };
    ;
    AnnualHomeBicycleModal.prototype.validateValue = function (updateFieldValidation) {
        var isValueValid = Boolean(this.state.item.value && this.state.item.value >= this.minValue && this.state.item.value <= this.maxValue);
        updateFieldValidation && this.setState({
            isValueValid: isValueValid
        });
        return isValueValid;
    };
    AnnualHomeBicycleModal.prototype.finishAddingItem = function () {
        var item = this.state.item;
        var isDescriptionValid = Boolean(item.description);
        var isLocationValid = Boolean(item.coverLocation);
        var isValueValid = this.validateValue(false);
        if (isDescriptionValid && isValueValid && isLocationValid) {
            item.flowValuable = true;
            item.added = true;
            this.setState({
                item: item
            });
            this.props.onConfirm(item);
        }
        else {
            this.setState({
                isDescriptionValid: isDescriptionValid,
                isValueValid: isValueValid,
                isLocationValid: isLocationValid
            });
        }
    };
    return AnnualHomeBicycleModal;
}(React.Component));
exports.default = AnnualHomeBicycleModal;
//# sourceMappingURL=AnnualHomeBicycleModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/valuableItemWidget/AnnualHomeBicycleModal.js
// module id = 3698
// module chunks = 0